export default "__VITE_ASSET__BKBpEjSb__"